import moduleFactory from '../moduleFactory'
const namespace = 'scheduled-jobs'

const store = moduleFactory(namespace)

const data = store.getters.data

store.getters.data = state => (dispatch) => {
  return data(state)(dispatch).map(f => {
    f.payload = JSON.stringify(f.payload)

    return f
  })
}

export default store



// WEBPACK FOOTER //
// ./src/store/modules/scheduled-jobs.js